require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-clare-scientist-yeast-engineer-code-fellows-graduate.json") })
        }
      }, "path---blog-meet-clare-scientist-yeast-engineer-code-fellows-graduate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-clare-scientist-yeast-engineer-code-fellows-graduate!./.cache/json/blog-meet-clare-scientist-yeast-engineer-code-fellows-graduate.json
// module id = 924
// module chunks = 231608221292675